import { useRuntimeConfig } from '#imports'
import type { RouteRecordRaw } from 'vue-router'

import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import { PARTNERSHIPS } from './routes-names'

export default (): RouteRecordRaw[] => {
  const { market } = useMarketplace()
  const { FF_ENABLE_US_TELCO_COMPARATORS_COUNTRIES } = useRuntimeConfig().public

  return [
    {
      name: PARTNERSHIPS.US_TELCO_COMPARISON,
      path: 'mobile-plans',
      component: () =>
        import('~/scopes/partnerships/pages/UsTelcoComparatorsLandingPage/UsTelcoComparatorsLandingPage.vue'),
      meta: {
        owners: ['bot-squad-us-b2c-services'],
        routeExists: () =>
          FF_ENABLE_US_TELCO_COMPARATORS_COUNTRIES.includes(market.countryCode),
        cache: 'public, max-age=43200',
        tracking: { contentGroup: 'Partnerships' },
      },
    },
    {
      name: PARTNERSHIPS.BOUYGUES_OFFERS_WEBVIEW,
      path: 'partnerships/webview',
      meta: {
        layout: false,
        tracking: { contentGroup: 'Partnerships' },
      },
      children: [
        {
          name: PARTNERSHIPS.WEBVIEW_BOUYGUES_OFFERS,
          path: 'bouygues-offers',
          component: () =>
            import('~/scopes/partnerships/pages/BouyguesOffersWebview/BouyguesOffersWebview.vue'),
          meta: {
            owners: ['bot-squad-partnerships-front'],
          },
        },
      ],
    },
  ]
}
